import { render, staticRenderFns } from "./SearchArea.vue?vue&type=template&id=dd062d46&scoped=true"
import script from "./SearchArea.vue?vue&type=script&lang=js"
export * from "./SearchArea.vue?vue&type=script&lang=js"
import style0 from "./SearchArea.vue?vue&type=style&index=0&id=dd062d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd062d46",
  null
  
)

export default component.exports